var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0312 9.21884C11.3079 9.21884 10.6142 9.50618 10.1028 10.0176C9.59131 10.5291 9.30398 11.2228 9.30398 11.9461C9.30398 12.6694 9.59131 13.3631 10.1028 13.8746C10.6142 14.386 11.3079 14.6734 12.0312 14.6734C12.7546 14.6734 13.4483 14.386 13.9597 13.8746C14.4712 13.3631 14.7585 12.6694 14.7585 11.9461C14.7585 11.2228 14.4712 10.5291 13.9597 10.0176C13.4483 9.50618 12.7546 9.21884 12.0312 9.21884ZM12.0312 16.4916C10.8257 16.4916 9.66957 16.0127 8.81713 15.1602C7.96469 14.3078 7.4858 13.1516 7.4858 11.9461C7.4858 10.7406 7.96469 9.58443 8.81713 8.73199C9.66957 7.87955 10.8257 7.40066 12.0312 7.40066C13.2368 7.40066 14.3929 7.87955 15.2454 8.73199C16.0978 9.58443 16.5767 10.7406 16.5767 11.9461C16.5767 13.1516 16.0978 14.3078 15.2454 15.1602C14.3929 16.0127 13.2368 16.4916 12.0312 16.4916ZM12.0312 5.12793C7.61307 5.12793 3.64943 7.8552 2.03125 11.9461C4.20398 17.4734 10.4403 20.1825 15.9676 18.0097C18.7403 16.9188 20.9403 14.7279 22.0312 11.9461C20.4131 7.8552 16.4494 5.12793 12.0312 5.12793Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_8771_167335)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.03125,
  y: 0.128906,
  width: 24,
  height: 24,
  fill: "#00538F"
}));

function SvgEye2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8771_167335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 21,
    height: 14
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye2.bc368a5a.svg";
export { ForwardRef as ReactComponent };